import React, { useState } from 'react'
import { Pagination } from 'react-bootstrap'

//Call this when using table and a lot data!!
function TablePagination(props) {
    const currentPage = props.currentPage
    const dataLength = props.dataLength
    const disabledPrev = props.disabledPrev
    const disabledNext = props.disabledNext

    const pageNumbers = []
    for(let i = 1; i<= dataLength; i++){
        pageNumbers.push(i)
    }

    const [paginationOffset, setOffset] = useState(0)
    const pageRange = props.size
    const lastIndexOffset = paginationOffset + pageRange

    const nextPageClick = () =>{
        if(currentPage === lastIndexOffset){
            setOffset(paginationOffset + pageRange)
        }
        props.nextClick()
    }

    const prevPageClick = () =>{
        if(currentPage === paginationOffset + 1){
            setOffset(paginationOffset - pageRange)
        }
        props.prevClick()
    }

    const gotoFirstPage = () =>{
        setOffset(0)
        props.firstPageClick(pageNumbers[0])
    }

    const gotoLastPage = () =>{
        let lastIndex = pageNumbers.length
        let lastOffset = (Math.ceil(pageNumbers.length/pageRange) * pageRange) - pageRange
        setOffset(lastOffset)
        props.lastPageClick(pageNumbers[lastIndex - 1])
    }

    return (
        <Pagination>
            <Pagination.First
            disabled={disabledPrev}
            onClick={()=>gotoFirstPage()}
            />
            <Pagination.Prev
            disabled={disabledPrev}
            onClick={()=>prevPageClick()}
            />
            { pageNumbers.slice(paginationOffset, lastIndexOffset).map((item, key)=>
            <Pagination.Item 
            key={key} 
            active={currentPage === item}
            onClick={(e)=>props.handlerPaginationClick(item)}>
                {item}
            </Pagination.Item>
            )}
            <Pagination.Next
            disabled={disabledNext}
            onClick={()=>nextPageClick()}
            />
            <Pagination.Last
            disabled={disabledNext}
            onClick={()=>gotoLastPage()}
            />
        </Pagination>
    )
}

export default TablePagination
